import i18n from "@/i18n"
import React from "react"
import styled from "styled-components"

const Main = styled.main`
    background: #fff;
    display: flex;
    width: 900px;
    max-width: 100%;
    flex-direction: column;
    overflow: hidden;
    align-items: center;
    font-weight: 800;
    justify-content: center;
    padding: 60px 20px 20px;
`

const MainHeading = styled.h1`
    color: #83c308;
    font-size: 34px;
    line-height: 44px;
    letter-spacing: -0.68px;
    text-align: center;

    .highlight-text {
    color: #222;
    }
`

const SubHeading = styled.h2`
    color: #222;
    font-size: 22px;
    letter-spacing: -0.44px;
    margin-top: 18px;
`

const Description = styled.p`
    color: #515151;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: -0.32px;
    text-align: center;
    margin-top: 18px;
`

const TemplateRowContainer = styled.div`
    display: flex;
    min-height: 220px;
    width: 100%;
    align-items: start;
    gap: 20px;
    justify-content: start;
    flex-wrap: wrap;
    margin-top: 20px;
    &:first-child {
      margin-top: 0;
    }
    cursor: pointer;
`

const TemplateVideo = styled.video`
    aspect-ratio: 2;
    object-fit: cover;
    object-position: center;
    width: 100%;
    border-radius: 12px;
    min-width: 240px;
    flex: 1;
    flex-basis: 0%;

    transition: 0.5s;
    &:hover {
        transform: scale(1.05);
    }
`

const TemplateGridContainer = styled.section`
    display: flex;
    width: 900px;
    max-width: 100%;
    flex-direction: column;
    justify-content: start;
`

function TemplateRow({ templates, onThumbnailClicked }) {
    return (
        <TemplateRowContainer>
            {templates.map((template, index) => (
                <TemplateVideo
                    onClick={onThumbnailClicked(template.id)}
                    src={template.src}
                    muted
                    autoPlay
                    loop
                    playsInline
                    webkit-playsinline
                />
            ))}
        </TemplateRowContainer>
    );
}

function TemplateGrid({ onThumbnailClicked, lang }) {
    const templates_ko = [
        [
            {
                "id": "602a155b75206f664a5c61d2",
                "thumbnail": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/horizontal/241206_01/602a155b75206f664a5c61d2_ko.jpg",
                "src": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/horizontal/241206_01/602a155b75206f664a5c61d2_ko.mp4"
            },
            {
                "id": "60b484e8ed76290034926de6",
                "thumbnail": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/horizontal/241206_01/60b484e8ed76290034926de6_ko.jpg",
                "src": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/horizontal/241206_01/60b484e8ed76290034926de6_ko.mp4"
            }
        ],
        [
            {
                "id": "61160efff1a96f013dca8622",
                "thumbnail": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/horizontal/241206_01/61160efff1a96f013dca8622_ko.jpg",
                "src": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/horizontal/241206_01/61160efff1a96f013dca8622_ko.mp4"
            },
            {
                "id": "64ba392d50aff80d84a89feb",
                "thumbnail": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/horizontal/241206_01/64ba392d50aff80d84a89feb_ko.jpg",
                "src": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/horizontal/241206_01/64ba392d50aff80d84a89feb_ko.mp4"
            }
        ],
        [
            {
                "id": "65cefe3fb15ab1146642bd9e",
                "thumbnail": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/horizontal/241206_01/65cefe3fb15ab1146642bd9e_ko.jpg",
                "src": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/horizontal/241206_01/65cefe3fb15ab1146642bd9e_ko.mp4"
            },
            {
                "id": "664af4f12bed431e50d8de1d",
                "thumbnail": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/horizontal/241206_01/664af4f12bed431e50d8de1d_ko.jpg",
                "src": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/horizontal/241206_01/664af4f12bed431e50d8de1d_ko.mp4"
            }
        ],
        [
            {
                "id": "6605470d29954d0298600add",
                "thumbnail": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/horizontal/241206_01/6605470d29954d0298600add_ko.jpg",
                "src": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/horizontal/241206_01/6605470d29954d0298600add_ko.mp4"
            },
            {
                "id": "67122438e0e54a005bcda963",
                "thumbnail": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/horizontal/241206_01/67122438e0e54a005bcda963_ko.jpg",
                "src": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/horizontal/241206_01/67122438e0e54a005bcda963_ko.mp4"
            }
        ]
    ];
    const templates_en = [
        [
            {
                "id": "602a155b75206f664a5c61d2",
                "thumbnail": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/horizontal/241206_01/602a155b75206f664a5c61d2_en.jpg",
                "src": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/horizontal/241206_01/602a155b75206f664a5c61d2_en.mp4"
            },
            {
                "id": "60b484e8ed76290034926de6",
                "thumbnail": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/horizontal/241206_01/60b484e8ed76290034926de6_en.jpg",
                "src": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/horizontal/241206_01/60b484e8ed76290034926de6_en.mp4"
            }
        ],
        [
            {
                "id": "61160efff1a96f013dca8622",
                "thumbnail": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/horizontal/241206_01/61160efff1a96f013dca8622_en.jpg",
                "src": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/horizontal/241206_01/61160efff1a96f013dca8622_en.mp4"
            },
            {
                "id": "64ba392d50aff80d84a89feb",
                "thumbnail": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/horizontal/241206_01/64ba392d50aff80d84a89feb_en.jpg",
                "src": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/horizontal/241206_01/64ba392d50aff80d84a89feb_en.mp4"
            }
        ],
        [
            {
                "id": "65cefe3fb15ab1146642bd9e",
                "thumbnail": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/horizontal/241206_01/65cefe3fb15ab1146642bd9e_en.jpg",
                "src": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/horizontal/241206_01/65cefe3fb15ab1146642bd9e_en.mp4"
            },
            {
                "id": "664af4f12bed431e50d8de1d",
                "thumbnail": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/horizontal/241206_01/664af4f12bed431e50d8de1d_en.jpg",
                "src": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/horizontal/241206_01/664af4f12bed431e50d8de1d_en.mp4"
            }
        ],
        [
            {
                "id": "6605470d29954d0298600add",
                "thumbnail": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/horizontal/241206_01/6605470d29954d0298600add_en.jpg",
                "src": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/horizontal/241206_01/6605470d29954d0298600add_en.mp4"
            },
            {
                "id": "67122438e0e54a005bcda963",
                "thumbnail": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/horizontal/241206_01/67122438e0e54a005bcda963_en.jpg",
                "src": "https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/landing_2024/horizontal/241206_01/67122438e0e54a005bcda963_en.mp4"
            }
        ]
    ]

    const templates = lang === "ko" ? templates_ko : templates_en
    return (
      <TemplateGridContainer>
        {templates.map((templates, index) => (
          <TemplateRow key={`row-${index}`} templates={templates} onThumbnailClicked={onThumbnailClicked} />
        ))}
      </TemplateGridContainer>
    )
  }

export default function HorizontalTemplateArea({ onThumbnailClicked, lang }) {
    return (
        <>
            <Main>
                <MainHeading>
                    {i18n.t("common.landing.template.heading_1")}<br />
                    <span className="highlight-text">{i18n.t("common.landing.ai.feature.heading_2")}</span>
                </MainHeading>
                <SubHeading>{i18n.t("common.landing.template.heading_2")}</SubHeading>
                <Description>
                    {i18n.t("common.landing.template.des_1")}
                    <br />
                    {i18n.t("common.landing.template.des_2")}
                    <br />
                    {i18n.t("common.landing.template.des_3")}
                </Description>
            </Main>
            <TemplateGrid
                onThumbnailClicked={onThumbnailClicked}
                lang={lang}
            />
        </>
    )
}